import mocuarao from "../assets/img/mocuarao.png";
import mongo from "../assets/img/mongo.png";
import coinam from "../assets/img/coinam.png";
import khaimon from "../assets/img/khaimon.png";
import ruocxuan from "../assets/img/ruocxuan.png";
import choixuan from "../assets/img/choixuan.png";
import tiensu from "../assets/img/tiensu.png";
import danbua from "../assets/img/danbua.png";
import danbuacuabac from "../assets/img/danbuacuabac.png";
import danbuacuadong from "../assets/img/danbuacuadong.png";
import danbuacuagiua from "../assets/img/danbuacuagiua.png";
import danbuacuanam from "../assets/img/danbuacuanam.png";
import danbuacuatay from "../assets/img/danbuacuatay.png";
import xocquach from "../assets/img/xocquach.png";
import truta from "../assets/img/truta.png";
import page339 from "../assets/img/pages/339.jpg"; //mo cua rao
import page340 from "../assets/img/pages/340.jpg"; //mo ngo

const nghiLeData = [
  {
    id: 1,
    title: "Mở cửa rào",
    page: "339",
    pageRange: [339],
    pageImages: [page339],
    videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765267096/mocuarao_ihca2r.mov",
    pageRange: [339],
    pageImages: [page339],
    content: `**Cái kể**: Nhà ông cửa kín rào cao,  
**Con xô**: Tôi vô chẳng đặng đứng ngoài tôi rao,  
**Cái kể**: Hôm qua để ngõ ông chờ ai,  
**Con xô**: Hôm nay tôi tới ngõ gài khăng khăng,  
**Cái kể**: Hôm qua để ngõ ông chờ trăng,  
**Con xô**: Hôm nay tôi tới khăng khăng ngõ gài,  
**Cái kể**: Nhà ông có thằng tớ trai  
Cái kể - Con xô: Sai ra mở ngõ, đàn trai tôi hát bùa.  
Cái kể - Con xô: Sai ra mở ngõ, đàn trai tôi hát bùa.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: mocuarao,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description:
      "Bài hát mở đầu nghi thức Sắc Bùa, hát trước cổng ngõ để xin phép vào nhà.",
    modernDevelopment:
      "Vẫn được biểu diễn trong các nghi lễ truyền thống tại Phú Lễ.",
  },
  {
    id: 2,
    title: "Mở ngõ",
    page: "340",
    pageRange: [340],
    pageImages: [page340],
    videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765267103/mongo_xrocn3.mov",
    content: `**Cái kể**: Ngõ này, ngõ ai  
Trên thời xây gạch  
Dưới tợ rồng bay  
Con phụng sắp bầy  
Khoen kia léo luống,  
Gài chặt khăng khăng,  
Có mở cùng chăng  
Hay là không mở?  
**Con xô**: Mở ngõ, mở ngõ,  
**Cái kể**: Khoen trên còn xỏ  
**Con xô**: Ngõ dưới còn đóng,  
**Cái kể**: Mở cửa cho chóng,  
**Con xô**: Cho chúng tôi vào,  
**Cái kể**: Trong nhà dọn dẹp.  
**Con xô**: Mở chẳng đặng nào  
**Cái kể**: Mở lấy mà vào  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: mongo,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description:
      "Bài hát tiếp nối Mở cửa rào, cầu mong sự thuận lợi khi vào nhà gia chủ.",
    modernDevelopment:
      "Tiếp tục được sử dụng trong các nghi lễ Sắc Bùa tại Phú Lễ.",
  },
  {
    id: 3,
    title: "Cõi Nam",
    content: `**Cái kể**: Câu bộc trúc nhất sanh trừ cựu tế  
Chữ đào phù vạn hộ là cảnh tân xuân  
Anh em tôi rày chơi xuân năm mới,…  
(vào nhịp) Cõi Nam đặt vững đời đời  
**Con xô**: Sao khuê rạng vẻ giữa trời rưng rưng.  
**Cái kể**: Tháng xuân chỉ có mấy lần,  
**Con xô**: Ngày xuân hớn hở đêm xuân rạng ngời.  
**Cái kể**: Mừng thay cô bác thảnh thơi,  
**Con xô**: Anh em chúng bạn vui chơi đêm ngày.  
**Cái kể**: Ông bà hòa vọng đêm ngày,  
**Con xô**: Sao chẳng cho người mở ngõ rước xuân.  
**Cái kể**: Anh em nho sỡi (sĩ) xa gần đến chơi.  
Luyện tập đã mấy năm chầy,  
**Con xô**: Lập thành bổn bạn rủ nhau hát bùa.  
**Cái kể**: Anh em tôi đi hát bùa,  
**Con xô**: Cầu cho năm mới chủ gia thanh nhàn.  
**Cái kể**: Cầu cho hương chức trong làng,  
**Con xô**: Bình an sức khỏe thương rày chúng dân.  
**Cái kể**: Cầu cho thôn xóm xa gần,  
**Con xô**: Bình an sức khỏe sống dư đời đời.  
**Cái kể**: Ông ngồi giường cặp chiếu bông,  
**Con xô**: Ông sai tôi tớ đã đông dày dày.  
**Cái kể**: Lúa thóc ông đổ đã đầy,  
**Con xô**: Gà nhốt trong lồng, lại có muôn săng.  
**Cái kể**: Tối trời sao chẳng có trăng,  
**Con xô**: Hai bên khóa chặt khăng khăng ngõ gài.  
**Cái kể**: Nhà ông có thằng tớ trai,  
Cái kể - Con xô: Sai ra mở ngõ, chúng tôi hát bùa,  
Cái kể - Con xô: Sai ra mở ngõ, chúng tôi hát bùa.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: coinam,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description:
      "Bài hát chào mừng mùa xuân, cầu chúc bình an và thịnh vượng cho dân làng.",
    modernDevelopment:
      "Vẫn là một phần quan trọng trong nghi lễ Sắc Bùa Phú Lễ.",
  },
  {
    id: 4,
    title: "Khai môn",
    videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765267104/khaimon_izbeid.mov",
    content: `**Cái kể**: Lới đàng trước ra vô bế hộ,  
Triệu tống sau môn đặng trùng khai.  
Khai nay trong nhà tinh sạch an bày  
Ngó ngoài ngõ tứ duy xuân mật.  
Bạn xuân mới khôn bề nhập thất,  
Chủ xin trình cho phép tôi khai môn.  
**Con xô**: Khai môn, khai môn,  
**Cái kể**: Thượng hạ càn khôn  
**Con xô**: Dựt ra tả hữu  
**Cái kể**: Đi giữa trung ương  
**Con xô**: Thẳng tới tiền đường  
**Cái kể**: Rước xuân cho chúa,  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: khaimon,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description: "Bài hát thực hiện nghi thức mở cửa nhà để rước xuân.",
    modernDevelopment:
      "Được biểu diễn trong các nghi lễ truyền thống tại Phú Lễ.",
  },
  {
    id: 5,
    title: "Rước xuân",
    videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765428625/ruocxuan_hmo8sh.mov",
    content: `**Cái kể**: Đêm ba mươi là đêm trừ tịch,  
Nửa canh ba chánh đán nguơn tiêu,  
Ngoài sân mừng quân tử dựng nêu,  
Rước Đông trù nhập trạch.  
Hương đốt đèn chong tinh sạch.  
Trẻ già làm lễ rước xuân.  
**Con xô**: Rước xuân, rước xuân.  
**Cái kể**: Pháo nổ tưng bừng.  
**Con xô**: Giường thờ hực hở  
**Cái kể**: Mừng tuổi ông bà  
**Con xô**: Trẻ trẻ, già già  
**Cái kể**: Vui mừng thêm tuổi  
**Con xô**: Bùa xà dán cửa  
**Cái kể**: Rượu uống đầy tô  
**Con xô**: Nhà đủ người no  
**Cái kể**: Lòng xuân phơi phới  
**Con xô**: Tam nương khai thới  
**Cái kể**: Ngũ phước lâm môn  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: ruocxuan,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description:
      "Bài hát chào đón mùa xuân, cầu chúc phước lành và thịnh vượng.",
    modernDevelopment: "Vẫn được biểu diễn trong các lễ hội xuân tại Phú Lễ.",
  },
  {
    id: 6,
    title: "Chơi xuân",
    videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765428776/choixuan_ns5fui.mov",
    content: `**Cái kể**: Một năm mười hai tháng,  
Một tháng là ba mươi ngày.  
Đầu xuân, chơi xuân có mấy lần,  
Dập dìu con én đưa thoi.  
Thắm thoát ngựa khu qua khỏi cửa,  
Anh em sắm sửa chơi xuân kẻo mà hết xuân đi.  
**Con xô**: Chơi xuân, chơi xuân  
**Cái kể**: Rực rỡ áo quần,  
**Con xô**: Tay vàng tay bạc,  
**Cái kể**: Chân hài chân hớn,  
**Con xô**: Dù Tây nhấp nhớn,  
**Cái kể**: Nón Bắc xum xuê,  
**Con xô**: Kẻ tới yết thần  
**Cái kể**: Người đi cung hỉ  
**Con xô**: Dập dìu đông lý  
**Cái kể**: Pháo nổ tư niên.  
Cái kể - Con xô: Năm mới giàu sang.  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: choixuan,
    videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765241733/choi-xuan_be4pzm.mp4",
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description:
      "Bài hát mô tả không khí vui tươi của mùa xuân và các hoạt động lễ hội.",
    modernDevelopment: "Tiếp tục được trình diễn trong các nghi lễ Sắc Bùa.",
  },
  {
    id: 7,
    title: "Tiên sư",
    content: `**Cái kể**: Tiên sư là tướng ở trời,  
Thờ khắp mọi nơi  
Ta thờ chung thiên hạ  
**Con xô**: Tiên sư! Tiên sư!  
**Cái kể**: Mạn trạch hữu dư,  
**Con xô**: Thánh hiền chi đức,  
**Cái kể**: Bát quái tổ sư,  
**Con xô**: Làm thầy làm thợ,  
**Cái kể**: Cũng nhờ tiên sư.  
**Con xô**: Qua sông qua nước  
**Cái kể**: Cũng rước tiên sư  
**Con xô**: Nhà giàu thờ kỉnh,  
**Cái kể**: Cũng thỉnh tiên sư  
Cái kể - Con xô: Năm mới giàu sang,  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: tiensu,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description: "Bài hát tôn vinh tiên sư, cầu mong sự che chở và phước lành.",
    modernDevelopment:
      "Vẫn được sử dụng trong các nghi lễ thờ cúng tại Phú Lễ.",
  },
  {
    id: 8,
    title: "Trừ tà",
    content: `**Cái kể**: Gia đinh ngọc sắc  
Quỉ mỵ tà tinh  
Thét lịnh Thiên đình  
Sai ta xuống bắt,  
Tà nào gian tặc  
Thì tránh cho xa  
Phải quái quỉ ma  
Tà ra cho hết,  
Đặng binh ra vào,  
Chém tà làm lịnh….  
Binh ta, binh ta  
**Con xô**: Bắt quỉ, bắt ma, (Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Bắt ra vật quách,  
**Con xô**: Vật quách chớ tha,  
**Cái kể**: Để nó trở ra,  
**Con xô**: Thì ta lộn vào,  
Cái kể - Con xô: Năm mới giàu sang,  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: truta,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description: "Bài hát mang ý nghĩa xua đuổi tà ma, bảo vệ gia chủ.",
    modernDevelopment:
      "Tiếp tục được biểu diễn trong nghi thức trừ tà tại Phú Lễ.",
  },
  {
    id: 9,
    title: "Xốc quách",
    content: `**Cái kể**: Nhà ông cao nền cao chực.  
Mực tốt lắm thay.  
Ngó lên đòn tay,  
Ngó ngay ong óng.  
Cổ tôi mang trống,  
Tay tôi cầm bùa.  
Nhớ thầy tổ xưa,  
Có câu tiền để.  
Ma thấy ma nể,  
Quỉ thấy quỉ vái.  
Quỉ vái bốn phương,  
Bốn phương dần dật.  
Dần dật bốn phương,…  
Ông đi đâu, ông đi cầu quan.  
Bà đi đâu, bà đi buôn bán,  
Chúng bạn đầy đa.  
Xá mở cửa ra,  
Mà nghe tôi …dẫn bùa.  
**Con xô**: Mà nghe tôi dẫn bùa.  
**Cái kể**: Xốc quách thằng quỉ nó ném ra.  
**Con xô**: Chớ cho thằng quỉ nó lộn tà vào đây.  
**Cái kể**: Nó ra rồi bùa trấn (chớ) đông tây,  
**Con xô**: Bản đào nam bắc đủ rày bốn phương.  
**Cái kể**: Bùa tôi thỉnh cùng ông Võ Vương,  
**Con xô**: Tứ tung ngũ hoành khắp hết bát môn.  
**Cái kể**: Càn, khảm (a), cấn, chấn, tốn, ly, khôn, đoài,  
**Con xô**: Bát quái dấu còn hỡi chăng!  
**Cái kể**: Thỉnh phù Thái thượng Lão quân  
**Con xô**: Hóa hóa tồn tồn luật lịnh như phi  
**Cái kể**: Thỉnh phù ông Hớn Chung Ly  
**Con xô**: Tay cầm gươm báu chém đầu tà ra  
**Cái kể**: Thỉnh phù Uất Lũy ông thần trà  
**Con xô**: Dán hết cửa nhà tín chủ bình an  
**Cái kể**: Tháng giêng chơi tiết ba xuân  
**Con xô**: Ngựa xe đậm đuộc chật đường âu ca  
**Cái kể**: Tháng hai đào mới trổ hoa  
**Con xô**: Gái trai gặp thuở nghi gia lương thần  
**Cái kể**: Tháng ba chơi tiết mùa xuân  
**Con xô**: Sông Ngân đền Võ tinh thần thảnh thơi  
**Cái kể**: Tháng tư hưởng lượt vui chơi  
**Con xô**: Nông tang đâu đó đua bơi rộng tầm  
**Cái kể**: Tháng năm giờ ngọ mùng năm  
**Con xô**: Thoàn đua đậm đuộc đi tầm Phúc Nguyên  
**Cái kể**: Tháng sáu mùng sáu tiết lành  
**Con xô**: Hiệu rằng đại chúc vui vầy sướng ca  
**Cái kể**: Tháng bảy thất tịch độ hà  
**Con xô**: Sum vầy Ngưu nữ một nhà ngao du  
**Cái kể**: Tháng tám chơi tiết trung thu  
**Con xô**: Người người giỡn nguyệt giao an đêm trường  
**Cái kể**: Tháng chín chơi ngày trùng hưng  
**Con xô**: Hay ba rượu cúc, trà ngon cõi hòe  
**Cái kể**: Tháng mười cỡi ngựa (mới) nhất dương  
**Con xô**: Ăn mừng đông chí tiết rày đương xuân  
**Cái kể**: Mười một là tháng tầm mơi  
**Con xô**: Cử thi bạch tuyết thượng bày mẫu đơn  
**Cái kể**: Tháng chạp là tháng tế thần  
**Con xô**: Rủ nhau săn bắn tinh thần tốt tươi  
**Cái kể**: Kể mười hai tháng có ngần  
**Con xô**: Ông bà ngồi hưởng mười phần ung dung  
**Cái kể**: Già an cõi thọ chánh thung  
**Con xô**: Gái trai gặp thuở đài xuân lâu dài  
**Cái kể**: Con trai ăn học có tài  
**Con xô**: Văn chương cẩm tú hơn người thế gian  
**Cái kể**: Gái trai phú quới vinh hoa  
**Con xô**: Ông bà ngồi hưởng tam đa lộc trời  
**Cái kể**: Xuân ngoài đã tám chín mươi  
**Con xô**: Tuổi rồng, tóc hạc, da bành các mơi  
**Cái kể**: Con con cháu cháu đời đời  
**Con xô**: Dây dưa đậm đuột sông dài núi cao  
**Cái kể**: Ruộng thời trăm mẫu có dư  
**Con xô**: Cấy đâu đặng đó trời cho đặng mùa  
**Cái kể**: Đến nay lúa thóc gom vô  
**Con xô**: Muôn muôn, vạn vạn biết khi đụn nào  
**Cái kể**: Vườn đầy cam, quýt, trâu, heo  
**Con xô**: Hay ha nó lớn khỏi theo giữ gìn  
**Cái kể**: Bổng lộc đem đến kìn kìn  
**Con xô**: Bốn mùa vượng tướng người trên đông nhiều  
**Cái kể**: Lập đời thiên địa thái diêu  
**Con xô**: Một nhà phú thọ thảm chiều giáng hương  
**Cái kể**: Đến đây đứng trước ngoài sân  
**Con xô**: Dẹp tà ma quỉ chúa lân vào nhà  
**Cái kể**: Đèn chong, chiếu sẵn trải ra  
Cái kể - Con xô: Chúng tôi ngồi xuống dán ba lá bùa.  
Cái kể - Con xô: Chúng tôi ngồi xuống dán ba lá bùa.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: xocquach,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description: "Bài hát trừ tà và cầu phước, mô tả việc dán bùa ở các hướng.",
    modernDevelopment: "Vẫn được sử dụng trong nghi thức dán bùa tại Phú Lễ.",
  },
  {
    id: 10,
    title: "Dán bùa cửa Đông",
    content: `**Cái kể**: Cửa này là cửa Đông phương.  
Ngọ Giáp Ất thuộc chi hành Mộc  
Chi Mẹo Dần dưỡng ở mùa xuân  
Trời có sanh Thái hiệu thần linh  
Quảng phương ấy trừ chơn tà quỉ  
Lá phù Quan đế mà trấn cửa Đông phương  
**Con xô**: Đông phương! Đông phương! (Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Xuất nhập hanh thông  
**Con xô**: Chói ngời trời mọc  
**Cái kể**: Mát mẻ gió xuân  
**Con xô**: Lộc tới rần rần  
**Cái kể**: Cả nhà cả cửa  
**Con xô**: Bốn mùa vượng tướng  
**Cái kể**: Một thuở hiển vang  
Cái kể - Con xô: Năm mới giàu sang,  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: danbuacuadong,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description:
      "Bài hát dán bùa ở cửa Đông, cầu mong sự thịnh vượng và bình an.",
    modernDevelopment:
      "Tiếp tục được biểu diễn trong nghi lễ dán bùa tại Phú Lễ.",
  },
  {
    id: 11,
    title: "Dán bùa cửa Nam",
    content: `**Cái kể**: Sắc Nam phương là Bính Đinh  
Hỏa hương tứ chi dựa ở mùa hè  
Thần chúc dương khê, quản quân này  
Quản quân ấy cầm cờ phóng trị  
Tay cầm cờ xích xí  
Mình bận giáp lông bào  
Đầu đội mão song giao  
Chân chuốc hài sư tử  
Ứng càn khôn hung dữ  
Loài quỉ mị thất kinh  
Ta rao cho bây từ đây kiếm chốn tàng hình  
Bằng lánh né gươm linh không thứ  
Là phù Xích đế mà trấn cửa Nam phương  
**Con xô**: Nam phương! Nam phương! (Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Sắc lịnh oai cường  
**Con xô**: Tà ra hướng ngọ  
**Cái kể**: Bước đến cung ly  
**Con xô**: Đờn trí ca thi  
**Cái kể**: Gia đình mạnh khỏe!  
**Con xô**: Lộc quyền đem tới  
**Cái kể**: Phước thọ đầy nhà  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: danbuacuanam,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description: "Bài hát dán bùa ở cửa Nam, cầu mong sức khỏe và phước thọ.",
    modernDevelopment: "Vẫn được biểu diễn trong nghi thức dán bùa tại Phú Lễ.",
  },
  {
    id: 12,
    title: "Dán bùa cửa giữa",
    videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765276141/danbuacuagiua_shcbly.mp4",
    content: `**Cái kể**: Bùa xà thì trấn hai bên  
Thái cực chúa tiên thì trấn ở giữa  
Miệng hét ra lửa, tay xách búa đồng  
Hóa phép thần thông, hô tà lực sĩ  
Bao nhiêu thần quỉ, ta nói cho hay  
Bùa xà trấn đây  
Trấn trạch nhà này  
Trung ương rày bổn bạn đến lấy.  
**Con xô**: Trung ương! Trung ương! (Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Trấn giữa bốn phương.  
**Con xô**: Một tay trạch quái  
**Cái kể**: Phải đều trốn đi  
**Con xô**: Có khí phục hơi  
**Cái kể**: Tà vào tiêu quách  
**Con xô**: Trấn ba bữa tết  
**Cái kể**: Tà mỵ đi xa  
**Con xô**: Mạnh khỏe cả nhà  
**Cái kể**: Âu ca trăm họ  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: danbuacuagiua,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description: "Bài hát dán bùa ở cửa giữa, bảo vệ trung tâm ngôi nhà.",
    modernDevelopment:
      "Tiếp tục được sử dụng trong nghi lễ Sắc Bùa tại Phú Lễ.",
  },
  {
    id: 13,
    title: "Dán bùa cửa Tây",
    content: `**Cái kể**: Cửa này là cửa Tây phương  
Canh Tân thuộc chi hành Kim  
Chi Thân Dậu dưỡng ở mùa thu  
Trời sai Bạch Đế thần linh  
Quảng phương ấy trừ tà quỷ dữ  
Lá phù Bạch Đế mà trấn cửa Tây phương  
**Con xô**: Tây phương! Tây phương! (Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Thanh tịnh trời thu  
**Con xô**: Tà ma tiêu tán  
**Cái kể**: Phước lộc đầy nhà  
**Con xô**: Vượng khí bền lâu  
**Cái kể**: Gia đạo bình an  
**Con xô**: Cả nhà thịnh vượng  
**Cái kể**: Một đời hiển vinh  
Cái kể - Con xô: Năm mới giàu sang,  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong các tài liệu về nghi lễ Sắc Bùa Phú Lễ.`,
    image: danbuacuatay,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description: "Bài hát dán bùa ở cửa Tây, cầu mong bình an và thịnh vượng.",
    modernDevelopment:
      "Tiếp tục được biểu diễn trong nghi lễ dán bùa tại Phú Lễ.",
  },
  {
    id: 14,
    title: "Dán bùa cửa Bắc",
    content: `**Cái kể**: Cửa này là cửa Bắc phương  
Nhâm Quý thuộc chi hành Thủy  
Chi Hợi Tý dưỡng ở mùa đông  
Trời sai Hắc Đế thần linh  
Quảng phương ấy trừ tà quỷ dữ  
Lá phù Hắc Đế mà trấn cửa Bắc phương  
**Con xô**: Bắc phương! Bắc phương! (Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Hàn khí tiêu tan  
**Con xô**: Tà ma tránh xa  
**Cái kể**: Phước lộc dồi dào  
**Con xô**: Gia đình an khang  
**Cái kể**: Cửa nhà vững chãi  
**Con xô**: Bốn mùa thịnh vượng  
**Cái kể**: Vinh hoa bền lâu  
Cái kể - Con xô: Năm mới giàu sang,  
Cái kể - Con xô: Gia quan tấn lộc.  

**Mốc thời gian**: Được ghi nhận trong các tài liệu về nghi lễ Sắc Bùa Phú Lễ.`,
    image: danbuacuabac,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description: "Bài hát dán bùa ở cửa Bắc, cầu mong an khang và phước lộc.",
    modernDevelopment:
      "Tiếp tục được biểu diễn trong nghi lễ dán bùa tại Phú Lễ.",
  },
  {
    id: 15,
    title: "Dẫn bùa",
    content: `**Cái kể**: Nhớ thuở xưa có Ca Thái Cực  
Ở đất lý hải lâm sang  
Ban một cô đồ khuya sớm  
Bạn cùng chí khí giễu hại chúng sanh  
Từ ấy Phật giành ở nơi đất Phật  
Vật chúng quỉ loạn trời loạn đất  
Còn mình Phật không bắt không tha  
Lên linh tiêu chớ khá dần dà  
Chầu Ngọc đế xảy ra chúng bắt  
Bắt lấy - chúng hắc tiểu hổ, chúng xà  
Bắt lấy quỉ ma đem về hành tội  
Phật bà vô ý bỏ rơi búa đồng  
Thới cực thấy người đặng chân lên ấy  
Phật bà xem thấy trốn vào cội cây  
Ai đem đến đây cho mi hại Phật bà  
Nói lại rằng khó, rằng nhựt, rằng nguyệt,  
Rằng linh, rằng tiêu  
Mấy chỗ linh tiêu, tà nên linh tiêu cho hết  
Bữa nay là bữa mùng (...) Tết tôi trừ quỉ trừ tà  
**Con xô**: Linh chúng là phải linh ta (Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Linh phù linh khuyết đem vào dán đây  
**Con xô**: Đông tây chỉ trạch  
**Cái kể**: Lá bùa tôi dán  
**Con xô**: Dán hết chiêm bao  
**Cái kể**: Cột cao hè thấp  
**Con xô**: Lú lấp đứa gian  
**Cái kể**: Khôn ngoan thằng tà  
**Con xô**: Ông bà mạnh khỏe  
**Cái kể**: Già trẻ (cho) sống lâu  
**Con xô**: Đỗ đầu cái khuyết  
**Cái kể**: Cái khuyết đòn tay  
**Con xô**: Ngó ngay châm chấm  
**Cái kể**: Hương cặm bàn thờ  
**Con xô**: Sào tơ sào áo  
**Cái kể**: Thúng gạo ghè tiền  
**Con xô**: Trấn bùa cửa trước  
**Cái kể**: Chủ rước làm giàu  
**Con xô**: (Tôi) trấn bùa cửa sau  
**Cái kể**: Chủ còn giàu nữa  
**Con xô**: Tôi trấn bùa cửa giữa  
**Cái kể**: Cho trẻ ăn nằm  
**Con xô**: Tôi trấn bùa mùng tằm  
**Cái kể**: Cho tằm ăn dâu  
**Con xô**: Tôi trấn bùa chuồng trâu  
**Cái kể**: Trâu sanh con cái  
**Con xô**: Thả ra đầy bãi (bái)  
**Cái kể**: Đuổi lại cũng đầy đàn  
**Con xô**: Bắt giàng cao tổ  
**Cái kể**: Ông ngồi cửa sổ  
**Con xô**: Lồ lộ (mới) xem qua  
**Cái kể**: Ả trai (cũng) thanh (à) tân  
**Con xô**: Người năm bảy vợ  
**Cái kể**: Ả gái (cũng) thanh tân  
**Con xô**: Cửi canh lụa là  
**Cái kể**: Nàng vợ thứ (a) ba  
**Con xô**: Bước ra khêu đèn  
**Cái kể**: Khêu đèn cho tỏ  
**Con xô**: Đêm khuya (để) kẻo lầm  
**Cái kể**: Cặp nem cậu để ở trên mâm  
**Con xô**: Nhạo rượu cậu cầm còn ở trên tay  
**Cái kể**: (Chớ) thảo thì (thời) rót (mới) ra đây  
**Con xô**: Mời ông hiệu tổ  
**Cái kể**: Đất này (mà) về dưng  
**Con xô**: Già già trẻ trẻ (mới) cũng dưng  
**Cái kể**: Dưng con dưng cháu  
**Con xô**: Lại dừng câu ca  
**Cái kể**: Lại thêm thạnh bò (mà) thạnh trâu  
**Con xô**: Thạnh con thạnh rể  
**Cái kể**: Thạnh đâu (ở) nhà này  
**Con xô**: Con trai thi đỗ trạng nguyên  
**Cái kể**: Con gái (mới) ở nhà  
**Con xô**: Lấy được chồng hiền  
**Cái kể**: Giàu sang phú quới (quí)  
**Con xô**: Nhờ ơn lá (à) bùa  
Cái kể - Con xô: Giàu sang phú quới  
Cái kể - Con xô: Nhờ ơn lá (à) bùa.  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: danbua,
    year: "Truyền thống",
    type: "Nghi lễ",
    icon: "🎶",
    description:
      "Bài hát kết thúc nghi thức dán bùa, cầu chúc phú quý và bình an.",
    modernDevelopment:
      "Vẫn được biểu diễn trong các nghi lễ Sắc Bùa tại Phú Lễ.",
  },
];

export default nghiLeData;
